export default __webpack_public_path__ + "static/media/featured-bg.74549727.png";